// extracted by mini-css-extract-plugin
export default {"backToTop":"GBackToTop-module_backToTop_fa4bd74c"};